<template>


   
        <div class="dashboard-wrapper">


           

            <cDPtopCards v-if="GET_SIGNIN_RES"></cDPtopCards>
            <div class="search-w">
                <div v-if="GET_SIGNIN_RES && GET_ORG_CURRENCY_RES" class="search-dash-option ">
                    <div row="12" class="book-option-wrapper">

        <div col="6" @click="toChangeSearchTypeOpt(SEARCH_OPTION.FLIGHTS)" 
            :class="searchOptionType.value==SEARCH_OPTION.FLIGHTS?'active':''" class="booking-option" >
          <div class="img">
            <img src="@/assets/mf/img/svg/icons/take-off.svg" width="17px" />
          </div>
          <div class="text">{{$t('searchPage.headerFlight')}}</div>
        </div>

        <div col="6" v-if="isHotelSearch"  :class="searchOptionType.value==SEARCH_OPTION.HOTEL?'active':''"
        @click="toChangeSearchTypeOpt(SEARCH_OPTION.HOTEL)" 
              class="booking-option" >
          <div class="img">
            <img src="@/assets/mf/img/svg/icons/take-off.svg" width="17px" />
          </div>
          <div class="text">Hotel</div>
        </div>
        
      </div>
        <cSearch v-if="isShowState &&  searchOptionType.value==SEARCH_OPTION.FLIGHTS"
                             :searchObject="search"
                             v-on:send="navToResultPage"

        />
        <div v-if="searchOptionType.value==SEARCH_OPTION.HOTEL">
         <cHotelSearch :searchObject="search" v-on:send="navToResultPage"> </cHotelSearch>
        </div>
        
                    <!-- <cSearch v-if="isShowState"
                             :searchObject="search"
                             v-on:send="navToResultPage"

                    />
                     -->
                </div>
            </div>


            <div class="table-list">
                <cDPminiTkt v-if="GET_SIGNIN_RES"></cDPminiTkt>

                <cDPminiBookingList v-if="GET_SIGNIN_RES"></cDPminiBookingList>

               
    </div>
        </div>
</template>
<script>
    import {
        getDiffBtwDates,
        addDays
    } from "../../util/date/dateFunctions.js";
    import cSearch from "../../components/search/cSearch";
    import {
        setFlightSearchHisToLocal,
        getSysLoginResFromLocal,
        getFlightSearchHisFromLocal,
        getHotelSearchHisFromLocal
    } from '../../applocalstorage/localStorage'

    import BaseConfiguration from "../../config/base";
    


    import cDPtopCards from "../../components/dashboard/cDPtopCards"
    import cDPminiTkt from "../../components/dashboard/cDPminiTkt"
    import cDPminiBookingList from "../../components/dashboard/cDPminiBookingList";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {mapActions, mapGetters} from "vuex";

    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import Logger from "../../services/logger";
    import apiDayToDaySales from "../../services/apiDayToDaySales"
    import Router from '../../router'
    import {addClassToBody, removeClassBody} from "../../util/util.js";
    import {PATHNAME, COMPONENT_NAME, TOAST_TYPE, SEARCH_OPTION} from '../../util/constants'
    import apiGetBalanceDetail from "../../services/apiGetBalanceDetail";
    import {handleJWT, getErrorAlertValue} from "../../util/util";
    import router, {navigate, goBack, updateCurrRouteQuery} from "../../router/index";
    import cHotelSearch from "../../components/booking/hotel/search/cHotelSearch";
    export default {
        name: 'Dashboard',
        components: {
            cDPtopCards,
            cDPminiTkt,
            cDPminiBookingList,
            cSearch,
           cHotelSearch
        },
        data() {
            return {
                searchOptionType: {
                    value:SEARCH_OPTION.FLIGHTS
                },
                SEARCH_OPTION : SEARCH_OPTION,
                isHotelSearch: BaseConfiguration.isHotelSearch,
                search: null,
                isShowState: true,

                dayToDaySalesRes: null,
                isShowBookingDetail: false,
                agentBookingDetail: {
                    ticketedBookings: null,
                    pendingBookings: null
                },
                userLogoDet: {
                    //logoDet: null,
                    b2bCompanyFinancess: []
                },
                // TOAST_TYPE:TOAST_TYPE,


            }
        },
        methods: {

...mapActions("sPaxPage", ["CLEAR_PAX_STORE"]),
    ...mapActions("sResult", ["CLEAR_RESULT_STORE"]),
    ...mapActions("sMLResult", ["CLEAR_ML_RESULT_STORE"]),
            ...mapActions("sDashBoard", {

                SET_AGENT_FINANCE_RESPONSE: "SET_AGENT_FINANCE_RESPONSE"
            }),
            ...mapActions("sCSearch", {
                SET_SEARCH_OBJ: "SET_SEARCH_OBJ",

            }),

            ...mapActions("sCMultiCitySearch", {
                SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",

            }),

            ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
      SET_HOTEL_SEARCH_OBJ: "SET_HOTEL_SEARCH_OBJ"}),

            toChangeSearchTypeOpt(pSearchOpt) {
                try {
                  if(BaseConfiguration.isDebug) console.log("toChangeSearchTypeOpt");
                  this.searchOptionType.value=pSearchOpt;
                  this.toAssignandGetSearchHis();
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_AGENT_DASHBOARD,
                          "error in toChangeSearchTypeOpt",
                          err.toString(),
                          "toChangeSearchTypeOpt",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
            }, 


            // async getDayToDaySales() {
            //     let returnValue;
            //     try {
            //         let dayToDaySalesReq = apiDayToDaySales.buildRequest();
            //         if (dayToDaySalesReq) {
            //             let dayToDaySalesRes = await apiDayToDaySales.getResponse(dayToDaySalesReq);
            //             if (VALIDATE_SUCCESS_RES(dayToDaySalesRes)) {
            //                 returnValue = dayToDaySalesRes.data.data;

            //             } else {
            //                 let error = getErrorMessage(dayToDaySalesRes);
            //                 let isJwt = handleJWT(error);
            //                 if (!isJwt) {
            //                     this.showAlert(getErrorAlertValue(error));
            //                 }
            //             }
            //         } else {
            //             throw "invalid request";
            //         }
            //     } catch (err) {
            //         let body = Logger.buildRequest(
            //             FILE_NAME.DASHBOARD,
            //             "error in  getDayToDaySales",
            //             err.toString(),
            //             " getDayToDaySales()",
            //             LOG_TYPE.ERROR
            //         );
            //         Logger.getResponse(body);
            //     }
            //     return returnValue;
            // },


            async getBalanceDetail(pB2bid) {
                let returnValue;
                try {
                    let balanceReq = apiGetBalanceDetail.buildRequest(pB2bid);
                    if (balanceReq) {
                        let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
                        if (VALIDATE_SUCCESS_RES(balanceRes)) {
                            returnValue = balanceRes.data.data;
                            this.SET_AGENT_FINANCE_RESPONSE(returnValue);
                        } else {
                            let error = getErrorMessage(balanceRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.DASHBOARD,
                        "error in  getBalanceDetail",
                        err.toString(),
                        " getBalanceDetail()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },


            // test(){
            //   location.replace('http://xyz.ascent24.io/testPage.html');
            // },


            getTicketingCount(bookDet) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTicketingCount");
                    // let retValue;
                    let ticketed = 0;
                    let pending = 0;
                    if (bookDet) {
                        for (let index = 0; index < bookDet.length; index++) {
                            const book = bookDet[index];
                            ticketed = ticketed + parseInt(book.ticketedbookings);
                            pending = pending + parseInt(book.pendingbookings);
                        }
                    }
                    this.agentBookingDetail.ticketedBookings = ticketed;
                    this.agentBookingDetail.pendingBookings = pending;
                    this.isShowBookingDetail = true;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.DASHBOARD,
                        "error in getTicketingCount",
                        err.toString(),
                        "getTicketingCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

     isValidDepAndArr(pHstryObj) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("checkDepAndArrCity");
         if(pHstryObj&&pHstryObj.route){
         for(let i=0;i<pHstryObj.route.length;i++){
           if(pHstryObj.route[i].from.depcode&&pHstryObj.route[i].from.arrcode.length>0&&pHstryObj.route[i].to.arrcode.length>0&&pHstryObj.route[i].to.depcode){
             retValue= true;
           }else{
             retValue= false;
             break;
           }
         }
         }
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SEARCHPAGE,
                  "error in checkDepAndArrCity",
                  err.toString(),
                  "checkDepAndArrCity",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        },
            //to asign search history to search values
            assignHistoryToSearch(pHstryObj) {
                if (BaseConfiguration.isDebug) console.log("assignHistoryToSearch");
                try {
                    if (pHstryObj != null&&this.isValidDepAndArr(pHstryObj)) {
                        this.isShowState = false;
                        let searchObj = this.setValidTravelDate(pHstryObj);
                        this.search = JSON.parse(JSON.stringify(searchObj));
                        let that = this;
                        setTimeout(function () {
                            that.isShowState = true;
                        });
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SEARCHPAGE,
                        "error in asignHistoryToSearch",
                        err.toString(),
                        "asignHistoryToSearch",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            //to navigate to search result page
            navToResultPage(pSearchObj, isMLSearch) {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToResultPage");
                    if (pSearchObj) {
                        this.search = pSearchObj;

                        if (isMLSearch) {
                            this.SET_ML_SEARCH_OBJ(this.search)
                            this.CLEAR_PAX_STORE();
                            this.CLEAR_ML_RESULT_STORE();
                            if(BaseConfiguration.isTourFlightResultsPage) {
            navigate(PATHNAME.TOUR_ML_FLIGHT_RESULTS);
          }else{
            navigate(PATHNAME.ML_FLIGHTRESULTS);
          }
                        } else {
                            
                            
                            this.CLEAR_PAX_STORE();
                            this.CLEAR_RESULT_STORE();
                             if(BaseConfiguration.isTourFlightResultsPage && this.searchOptionType.value!=SEARCH_OPTION.HOTEL) {
                                 this.SET_SEARCH_OBJ(this.search);
                               navigate(PATHNAME.TOUR_FLIGHT_RESULTS); 
                              }
                              else if(BaseConfiguration.isHotelSearch && this.searchOptionType.value==SEARCH_OPTION.HOTEL){
                              this.SET_HOTEL_SEARCH_OBJ(this.search);
                               navigate(PATHNAME.HOTEL_RESULT);
                                }
                                else{
                                 this.SET_SEARCH_OBJ(this.search);
                               navigate(PATHNAME.FLIGHTRESULTS);
                                }

                        }


                    } else {
                        this.showToast(
                            " Invalid search Object",
                            TOAST_TYPE.ERROR,
                            1000,
                            null
                        );
                    }
                    // if (this.storeSearchHistory(this.search)) {

                    //  }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SEARCHPAGE,
                        "error while navigation",
                        err.toString(),
                        "navToResultPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            getSearchHistory(pUserId) {
                if (BaseConfiguration.isDebug) console.log("getSearchHistory");
                try {
                    let sHistory = [];
                     let history;
        if (pUserId) {
          if(this.searchOptionType.value == SEARCH_OPTION.FLIGHTS) {
           history = JSON.parse(
           getFlightSearchHisFromLocal(pUserId)
          );
          }else if(this.searchOptionType.value == SEARCH_OPTION.HOTEL) {
            history = JSON.parse(
           getHotelSearchHisFromLocal(pUserId)
          );
          }
                        if (history) {
                            sHistory = history
                        }
                    }
                    return sHistory;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SEARCHPAGE,
                        "error in getSearchHistory",
                        err.toString(),
                        "getSearchHistory",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            setValidTravelDate(pHistoryObj) {
                try {
                    let historyObj = JSON.parse(JSON.stringify(pHistoryObj));
                    if (historyObj.route && historyObj.route.length > 0) {
                        if (historyObj.route[0] && historyObj.route[0].date) {
                            if (
                                getDiffBtwDates(
                                    new Date(historyObj.route[0].date),
                                    new Date(),
                                    "days"
                                ) >= 0
                            ) {
                                historyObj.route[0].date = new Date(historyObj.route[0].date);
                            } else {
                                historyObj.route[0].date = new Date();
                            }
                        }
                        if (historyObj.route[1] && historyObj.route[1].date) {
                            if (
                                getDiffBtwDates(
                                    new Date(historyObj.route[1].date),
                                    new Date(historyObj.route[0].date),
                                    "days"
                                ) >= 0
                            ) {
                                historyObj.route[1].date = new Date(historyObj.route[1].date);
                            } else {
                                historyObj.route[1].date = new Date(addDays(new Date(historyObj.route[0].date), 7));
                            }
                        }
                    }

                    return historyObj;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SEARCHPAGE,
                        "error in setValidTravelDate",
                        err.toString(),
                        "setValidTravelDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toAssignandGetSearchHis() {
                try {
                  if(BaseConfiguration.isDebug) console.log("toAssignandGetSearchHis");
                  let userId;
                if (this.USER_ID) {
                    userId = this.USER_ID;
                }
                this.searchHistory = this.getSearchHistory(userId);
                if (this.searchHistory.length > 0) {
                    this.assignHistoryToSearch(this.searchHistory[this.searchHistory.length - 1].search)
                }else{
                    this.search=null;
                }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_AGENT_DASHBOARD,
                          "error in toAssignandGetSearchHis",
                          err.toString(),
                          "toAssignandGetSearchHis",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
          }, 

        },


        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sDashBoard", {
                userLogoDetail: "GET_AGENT_LOGO_DET_RES",
            }),
            ...mapGetters('sAgtLogin', {GET_SIGNIN_RES: 'GET_SIGNIN_RES'}),
            ...mapGetters("sDashBoard", {
                USER_ID: "GET_USER_ID"
            }),
            ...mapGetters("sCurrencyLs", {
     
      GET_ORG_CURRENCIES: "GET_ORG_CURRENCIES",
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    }),

        },

        // beforeCreate() {
        //     addClassToBody(COMPONENT_NAME.DASHBOARD);
        // },

        // beforeDestroy() {
        //     removeClassBody();
        // },
        async created() {
            // if (BaseConfiguration.isDebug) console.log("created");
            try {

                this.$root.$emit("toggle-sidebar-minimize", true);


                /* for (let index = 0; index < 25; index++) {
      throw 'reference Error'

    }  */


                if (this.userLogoDetail && this.GET_SIGNIN_RES)
                    this.userLogoDet.b2bCompanyFinancess = await this.getBalanceDetail(this.userLogoDetail.b2bid ? this.userLogoDetail.b2bid : null);
                if (this.userLogoDet.b2bCompanyFinancess) {
                    this.getTicketingCount(this.userLogoDet.b2bCompanyFinancess);
                }


                this.toAssignandGetSearchHis();
                // if (this.ADMIN_SIGNIN_RES) {
                //     this.dayToDaySalesRes = await this.getDayToDaySales();


                // }

            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT_DASHBOARD,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }

        }

    }
</script>
<style>
    [v-cloak].c-sidebar c-sidebar-dark c-sidebar-show c-sidebar-fixed {
        display: none;
    }
</style>
